import { Box, Grid, IconButton, ListItemButton, Popover } from '@mui/material';
import React from 'react';
import { AiFillFileWord } from 'react-icons/ai';
import { BsFillFilePdfFill } from 'react-icons/bs';
import { MdDownload, MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { ICandidate } from 'wisestep-api';
import { Button, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { ResumeDetails } from '../../../features/candidates/utils/CandidateHelper';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
import { downloadCV, trackCV } from '../utils/cvHelper';

interface SwitchResumesProps {
  candidate: ICandidate;
  changeResume: (url: string, name: string) => void;
  candidateResumes: ResumeDetails[] | null;
}

const SwitchResumes = ({ changeResume, candidateResumes = [] }: SwitchResumesProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const cvViewSourcePage = useConversationWidgetStore((state) => state.cvViewSourcePage);
  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [resume, setResume] = React.useState<ResumeDetails | null>(candidateResumes?.[0] ?? null);
  const ChangeResume = (resume: ResumeDetails) => {
    setAnchorEl(null);
    setResume({ ...resume, url: resume.url.split('?')[0] });
    changeResume(resume.url.split('?')[0], resume.fileName);
  };
  const CvDownload = () => {
    if (resume?.url) {
      trackCV('download', resume?.url, cvViewSourcePage);
      downloadCV(resume?.url, resume?.fileName);
    }
  };

  return (
    <Box mt={0.2}>
      <Grid className="resume-files" item xs={12}>
        <Button
          onClick={handleClickOpen}
          sx={{
            justifyContent: 'flex-start',
            '&:hover': {
              background: 'none',
            },
          }}
          fullWidth
        >
          <Grid container item xs={12}>
            <Box px={0.5} mt={0.2}>
              {resume?.url.split('.').pop() === 'pdf' ? (
                <BsFillFilePdfFill color={WsColors.Red500} size={18} />
              ) : (
                <AiFillFileWord color={WsColors.TheBlues500} size={18} />
              )}
            </Box>
            <Box px={1}>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                {resume?.fileName?.substring(0, 36) ??
                  candidateResumes?.[0]?.fileName?.substring(0, 36)}
              </WsTypography>
            </Box>
            <Box
              borderRadius={2}
              bgcolor={WsColors.TheBlues200}
              height={25}
              width={25}
              alignItems="center"
              textAlign="center"
              pt={0.5}
            >
              <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.PRIMARY}>
                {candidateResumes?.length}
              </WsTypography>
            </Box>
            <Box px={0.5} mt={0.2}>
              {anchorEl !== null ? (
                <MdOutlineExpandLess color={WsColors.TheBlues500} size={23} />
              ) : (
                <MdOutlineExpandMore color={WsColors.TheBlues500} size={23} />
              )}
            </Box>
            <IconButton
              onClick={CvDownload}
              sx={{
                p: 0,
                pb: 0.5,
                '&:hover': {
                  background: 'none',
                },
              }}
            >
              <MdDownload color={WsColors.TheBlues500} size={20} />
            </IconButton>
          </Grid>
        </Button>
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {candidateResumes?.map((candidateResume, index) => (
          <ListItemButton
            onClick={() => ChangeResume(candidateResume)}
            key={index}
            sx={{ py: 0, minHeight: 32, color: 'red' }}
          >
            <Grid item container xs={12}>
              <Box px={0.5}>
                {candidateResume.url.split('?')[0].split('.').pop() === 'pdf' ? (
                  <BsFillFilePdfFill color={WsColors.Red500} size={20} />
                ) : (
                  <AiFillFileWord color={WsColors.TheBlues500} size={20} />
                )}
              </Box>
              <Box px={1}>
                <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.BLACK}>
                  {candidateResume.fileName}
                </WsTypography>
              </Box>
              <Box pr={0.5}>
                <MdDownload color={WsColors.TheBlues500} size={20} />
              </Box>
            </Grid>
          </ListItemButton>
        ))}
      </Popover>
    </Box>
  );
};
export default SwitchResumes;
